export enum Step {
  BusinessDetails,
  SelectCover,
  /**
   * @note cover details steps (used depending if user has selected that cover)
   */
  CoverDetailsLiability,
  CoverDetailsBuildingAndContents,
  CoverDetailsBusinessInterruption,
  CoverDetailsPortableItems,
  CoverDetailsTheft,
  CoverDetailsMoney,
  CoverDetailsGlass,
  CoverDetailsBreakdown,
  CoverDetailsTaxAudit,
  Membership,
  Quote,
  ExtraInfoCustomerHistory,
  ExtraInfoMoreBusinessDetails,
  Review,
  Payments,
  Confirmation,
}

export enum TaxIndicator {
  Full = 'T',
  Partial = 'P',
  NoITC = 'I',
  NotRegistered = 'N',
  InValid = '',
  Unknown = 'X',
}

export enum SimpleQuestionAnswer {
  Yes = 'Yes',
  No = 'No',
}

export enum API {
  CommercialInsurance,
  Payments,
  Sitecore,
}

export enum States {
  ACT = 'ACT',
  NSW = 'NSW',
  NT = 'NT',
  QLD = 'QLD',
  VIC = 'VIC',
  SA = 'SA',
  WA = 'WA',
  TAS = 'TAS',
}

export enum IdleSession {
  Timeout = 25, // min
  Countdown = 5, // min
}

export enum RetrieveQuoteFlow {
  Success = 'Success',
  PastEffectiveDate = 'PastEffectiveDate',
  Failed = 'Failed',
}

export enum SumInsuredType {
  Building = 'Building',
  Contents = 'Contents',
}

export enum TextFieldState {
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Default = '',
}
